/* eslint-disable no-unused-vars */
import { memo, useId } from 'react';
import * as S from './RadioBox.styled';
import PropTypes from 'prop-types';

const RadioBoxTemplate = memo(
  ({
    desc,
    style,
    icon,
    value,
    onChange = () => {},
    label = '',
    variant,
    width,
    height,
    disabled,
    pressed = false,
    type,
  }) => {
    const onClickFunc = () => {
      onChange(value, label);
    };
    const btnId = useId();
    return (
      <S.Container
        name={btnId}
        id={btnId}
        style={style}
        width={width}
        height={height}
        variant={variant}
        disabled={disabled}
        pressed={pressed}
        onClick={onClickFunc}
        type={type}
      >
        {icon && <S.IconContainer>{icon()}</S.IconContainer>}
        <S.Text>{label}</S.Text>
        {desc && <S.Desc>{desc}</S.Desc>}
      </S.Container>
    );
  },
);

const NormalSize = ({
  width,
  style,
  value,
  onChange,
  label,
  variant,
  disabled,
  pressed = false,
  type,
}) => {
  return (
    <RadioBoxTemplate
      style={style}
      width={width}
      height={40}
      variant={variant}
      disabled={disabled}
      pressed={pressed}
      onChange={onChange}
      label={label}
      value={value}
      type={type}
    />
  );
};

const SmallSize = ({
  width,
  style,
  value,
  onChange,
  label,
  variant,
  disabled,
  pressed = false,
  type,
}) => {
  return (
    <RadioBoxTemplate
      style={style}
      width={width}
      height={32}
      variant={variant}
      disabled={disabled}
      pressed={pressed}
      onChange={onChange}
      label={label}
      value={value}
      type={type}
    />
  );
};

const CustomWithIcon = ({
  style,
  value,
  onChange,
  label,
  variant,
  disabled,
  pressed = false,
  width,
  height,
  icon,
  type,
}) => {
  return (
    <RadioBoxTemplate
      icon={icon}
      style={style}
      width={width}
      height={height}
      variant={variant}
      disabled={disabled}
      pressed={pressed}
      onChange={onChange}
      label={label}
      value={value}
      type={type}
    />
  );
};

const CustomWithDesc = ({
  style,
  value,
  onChange,
  label,
  variant,
  disabled,
  pressed = false,
  width,
  height,
  desc,
  type,
}) => {
  return (
    <RadioBoxTemplate
      style={{ ...style, ...descStyle }}
      width={width}
      height={height}
      variant={variant}
      disabled={disabled}
      pressed={pressed}
      onChange={onChange}
      label={label}
      value={value}
      desc={desc}
      type={type}
    />
  );
};

const descStyle = {
  padding: '16px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  fontSize: '16px',
};

CustomWithDesc.propTypes = {
  desc: PropTypes.string.isRequired,
};

CustomWithIcon.propTypes = {
  icon: PropTypes.func.isRequired,
};

RadioBoxTemplate.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  variant: PropTypes.oneOf(['center', 'left', 'right']),
  disabled: PropTypes.bool,
  pressed: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
};

RadioBoxTemplate.displayName = 'RadioBoxTemplate';

export const RadioBox = {
  NormalSize,
  SmallSize,
  CustomWithIcon,
  CustomWithDesc,
};
